document.addEventListener('DOMContentLoaded', function() {
    // Dropdown button, list, and items.
    const dropdownButton = document.querySelector('.custom-dropdown-btn');
    const dropdownItemsList = document.querySelector('.custom-dropdown-items');
    const dropdownItems = document.querySelectorAll('.custom-dropdown-items li');

    // Toggle the dropdown list when the button is clicked.
    dropdownButton.addEventListener('click', function() {
        dropdownItemsList.classList.toggle('toggle');
    });

    // Add click event for each dropdown item.
    dropdownItems.forEach(item => {
        item.addEventListener('click', function() {
            // If this item is disabled, do nothing.
            if (this.classList.contains('disabled')) return;

            // Remove 'active' from all items.
            dropdownItems.forEach(i => i.classList.remove('active'));
            // Add 'active' class to the clicked item.
            this.classList.add('active');
            // Update the button's text with the selected option.
            dropdownButton.querySelector('span').textContent = this.textContent;
            // Hide the dropdown.
            dropdownItemsList.classList.remove('toggle');
        });
    });
});